import React from 'react'

const SlowFastMovingStock = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Slow-moving / Fast-moving stock</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Reports</li>
            <li className="breadcrumb-item active">Slow-moving / Fast-moving stock</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Slow-moving / Fast-moving stock</h5>
                <p>Slow-moving / Fast-moving stock content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default SlowFastMovingStock

